import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'customfilter',
    pure: true
})
export class CustomFilterPipe implements PipeTransform {
    transform(items: any[], filter: string): any {
        if (!items || !filter || filter === '') {
            return items;
        }
        return items.filter(item => {
             return +item['package_cat'] === +filter;
        });
}
}
